module.exports = __webpack_public_path__ + "media/components/documents/images/taxReturnForms/1120S-45df22c4966b4cc6f1745c80ba3c5e0c.png";